import { render, staticRenderFns } from "./ControlOverlay.vue?vue&type=template&id=2ff2ec7b&scoped=true&"
import script from "./ControlOverlay.vue?vue&type=script&lang=js&"
export * from "./ControlOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ControlOverlay.vue?vue&type=style&index=0&id=2ff2ec7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff2ec7b",
  null
  
)

export default component.exports